// ali AMS 监控
if (process.env.VUE_APP_ENV === 'prod' || process.env.VUE_APP_ENV === 'pre') {
  const BrowserLogger = require('alife-logger')

  window.__bl = BrowserLogger.singleton({
    pid: '9wuupinnea@0560a2f9c735bc3',
    appType: 'web',
    imgUrl: 'https://arms-retcode.aliyuncs.com/r.png?',
    sendResource: true,
    enableLinkTrace: true,
    behavior: true,
    enableSPA: true,
    useFmp: true,
    enableConsole: true,
    environment: process.env.VUE_APP_ENV === 'prod' ? 'prod' : 'daily',
    setUsername: function () {
      let userId = 'noauth'
      let userInfo = localStorage.getItem('USER')
        ? JSON.parse(localStorage.getItem('USER'))
        : null
      userId = userInfo && userInfo.userId ? userInfo.userId : userId
      return userId + ''
    },
    ignore: {
      ignoreApis: [
        'aegis.qq.com',
        'soe-eks.qcloud.com',
        'videocloud.cn-hangzhou.log.aliyuncs.com',
        'log.dayuan1997.com',
      ],
    },
  })
}
